// src/components/CharacterAndInventoryView.js
import React from 'react';
import styles from './CharacterAndInventoryView.module.css';
import CharacterDisplay from './CharacterDisplay';
import InventoryDisplay from './InventoryDisplay';

// Accept lock functions
const CharacterAndInventoryView = ({ playerData, setPlayerData, onEquipItem, onUnequipItem, onUseItem, onToggleItemLock, isItemLocked, tooltipsEnabled = true }) => {
  return (
    <div className={styles.viewContainer}>
      <div className={styles.characterPanel}>
        <CharacterDisplay
          playerData={playerData}
          onUnequipItem={onUnequipItem}
          tooltipsEnabled={tooltipsEnabled}
        />
      </div>
      <div className={styles.inventoryPanel}>
        <InventoryDisplay
          playerData={playerData}
          setPlayerData={setPlayerData}
          onEquipItem={onEquipItem}
          onUseItem={onUseItem} // Pass onUseItem down
          onToggleItemLock={onToggleItemLock}
          isItemLocked={isItemLocked}
        />
      </div>
    </div>
  );
};

export default CharacterAndInventoryView;